// src/contexts/VersionContext.jsx
import { createContext, useContext, useState, useEffect } from 'react';
import { getLastVersion } from '../../api';

const VersionContext = createContext();

export const VersionProvider = ({ children }) => {
  const [version, setVersion] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLastVersion()
      .then((version) => {
        setVersion(version);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch version:', error);
        setLoading(false);
      });
  }, []);

  return (
    <VersionContext.Provider value={{ version, loading }}>
      {children}
    </VersionContext.Provider>
  );
};

export const useVersion = () => useContext(VersionContext);
